export const APPROVAL_REQUEST_FILTERS = {
  open: {
    value: 'open',
    label: 'Show Open Issues',
  },
  closed: {
    value: 'closed',
    label: 'Show Closed Issues',
  },
  all: {
    value: 'all',
    label: 'Show All Issues',
  },
}

export const SET_APPROVAL_REQUEST_FILTER_OPEN = 'SET_APPROVAL_REQUEST_FILTER_OPEN'
export const SET_APPROVAL_REQUEST_FILTER_CLOSED = 'SET_APPROVAL_REQUEST_FILTER_CLOSED'
export const SET_APPROVAL_REQUEST_FILTER_ALL = 'SET_APPROVAL_REQUEST_FILTER_ALL'
export const SET_APPROVAL_REQUEST_GROUP_BY_AI_CODE = 'SET_APPROVAL_REQUEST_GROUP_BY_AI_CODE'
export const SET_APPROVAL_REQUEST_DISTANT_SCHOOLS = 'SET_APPROVAL_REQUEST_DISTANT_SCHOOLS'
export const SET_APPROVAL_REQUEST_AI_CODE_FILTER = 'SET_APPROVAL_REQUEST_AI_CODE_FILTER'
